import React, { Component } from 'react';
import BannerForm from '../../../../components/SiteAdmin/ShopHomepageSettings/BannerForm';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import getAllPartnerHomepage from './getAllPartnerHomepage.graphql';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './BannerSettings.css';
import Loader from '../../../../components/Common/Loader/Loader';
export class BannerSettings extends Component {

    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getAllPartnerHomepage } } = this.props;
        let initialValues = {};
        let homepageCollection = {};

        getAllPartnerHomepage && getAllPartnerHomepage.homePageData.map((item) => {
            homepageCollection[item.name] = item.value
        })

        return (
            <div>
                <Loader type={"page"} show={loading}>
                    <div className={s.root}>
                        <div className={s.container}>
                            {!loading && <BannerForm initialValues={homepageCollection} />}
                        </div>
                    </div>
                </Loader>
            </div>
        )
    }
}

export default compose(
    withStyles(s),
    graphql(getAllPartnerHomepage, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(BannerSettings)
